import React, {
  Fragment,
  useCallback,
  useRef,
  useState,
  useEffect,
} from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useUpdateEffect, usePrevious, useMount } from 'react-use';
import { useHistory } from 'react-router-dom';
import cn from 'classnames';
import copy from 'copy-to-clipboard';
import {
  Button, Avatar, Collapse, Tag, Empty,
  Popconfirm, Tooltip, message, Timeline,
  Tabs, Table, Icon, Row, Col, Rate, Input,
  Modal, Dropdown, Menu, Badge
} from 'antd';
import dayjs from 'dayjs';
import * as utils from '@/utils';
import { findById } from '@/models/orders/selectors';
import MapDialog from '@/components/MapDialog';
import TenantLogo from '@/components/TenantLogo';
import ChangePrice from '../ChangePrice';
import AddExpress from '../AddExpress';
import AddAccessory from '../AddAccessory';
import ExpressDetail from '../ExpressDetail';
import CancelOrder from '../CancelOrder';
import TenantCancelOrder from '../TenantCancelOrder';
import GuaqiOrder from '../GuaqiOrder';
import Reminder from '../Reminder';
import MemoList from '@/components/MemoList';
import AlbumPreview from '@/components/AlbumPreview';
import AlbumPreviewCover from '@/components/AlbumPreview/cover';
import styles from './styles.module.less';
import PhotoSwipe from 'photoswipe/dist/photoswipe';
import * as orderActions from '@/models/orders/actions';
import * as messageActions from '@/models/messages/actions';
import PhotoSwipeUI_Default from 'photoswipe/dist/photoswipe-ui-default';
import CallNumber from '@/components/CallNumber';
import VeteranStatus from '@/components/VeteranStatus';
import {
  showPriceDialog,
  showExpressDialog,
  showExpressDetailDialog,
  showServiceTimeDialog,
  showAssignWorkerDialog,
  lockFee,
  orderPreview,
  showCreateOrderDialog,
  showAppealDialog,
  sendWorkerToUser,
  closeOrder,
  refuseCloseOrder,
  showCanceOrderDialog,
  showAccessoryDetailDialog,
  showOrderEvaluateDialog,
  showOredrReminder
} from '@/models/orders/actions';
import { showInfoDialog as showProductInfo } from '@/models/products/actions';
import ProductInfoDialog from '@/components/dialogs/ProductInfoDialog';
import ChangeServiceTimeDialog from '@/components/dialogs/ChangeServiceTimeDialog';
import AssignWorkerDialog from '@/components/dialogs/AssignWorkerDialog';
import OrderEvaluateDialog from '@/components/dialogs/OrderEvaluateDialog';
import { orderStatus } from '@/models/orders/defines/constants';
import StatusBadge from '@/components/StatusBadge';
import BlinkingBadge from '@/components/BlinkingBadge';
import ControlBtns from './ControlBtns';
import OrderNotice from './OrderNotice';
import TenantStatusBadge from '../TenantStatusBadge';
import { getOrder as fetchOrder } from 'models/orders/actions';
import { sendMessage } from '@/models/messages/actions';
import { getCurrentUser } from '@/models/user/selectors';
import * as services from '@/models/orders/services';
import { deburr } from 'lodash';
import * as apis from '@/apis'
import { orderStatusMappings } from 'utils';
import Countdown from '@/components/Countdown';

const { TabPane } = Tabs;
const { Panel } = Collapse;
const { fromJS, List } = require('immutable');
function OrderRow(props) {
  return (
    <div className={cn(styles.row, props.block && styles.block)}>
      <div className={styles.rowTit}>{props.title}</div>
      <div className={styles.rowBody}>{props.children}</div>
    </div>
  );
}

function SectionTitle(props) {
  return (
    <div className={styles.sectionTitle}>
      <span className={styles.title}>{props.title}</span>
      <div className={styles.line}></div>
      {props.children}
    </div>
  );
}

export default function OrderDetail({
  className,
  readOnly = false,
  isDrawer = false,
  orderId,
  tid,
  forceSync,
  ...props
}) {
  const tenantMode = process.env.APP_MODE === 'tenant';
  const isManagerMode = process.env.APP_MODE === 'manager';
  const dispatch = useDispatch();
  const order = useSelector(findById(orderId));
  const user = useSelector(getCurrentUser);
  const prevOrderId = usePrevious(orderId);
  const $scrollEl = useRef(null);
  const platformChecked = order && order?.get('platform_checked');
  const isActive = order && order?.get('active_state') === 1;
  const orderReceived = order && order?.get('receive_state') == 1;
  const workerCompleted = order && order?.get('worker_completed');
  const status = order && utils.getStatus(order);
  const orderJs = order && order?.toJS();
  const [events, setEvents] = React.useState([]);
  const woker_services = orderJs && orderJs.worker_services;
  const hasWorker = order && order?.get('worker')
  const waitTenantConfirmStatus = order && order?.get('status_code') === orderStatus.PROCESSING_WAIT_TENANT_RECEIPT

  const showConfirmBtn = hasWorker && workerCompleted && !platformChecked
  const showTenantConfirmBtn = tenantMode && waitTenantConfirmStatus
  const [serviceMemo, setServiceMemo] = useState([]);
  const [businessMemo, setBusinessMemo] = useState([]);
  const [workerMemo, setWorkerMemo] = useState([]);
  const [memoValue, setMemoValue] = useState('');

  const [evaluateInfo, setEvaluateInfo] = useState({});
  const [claimOkList, setClaimOkList] = useState([]);

  const getOrderWaitOp = (orderId) => {
    services.orderWaitOp({ orderId })
      .then((result) => {
        setClaimOkList(result?.claimOkList || [])
      })
      .catch((err) => {
        message.error(err.message || '获取数据失败，请刷新重试');
      })
      .finally(() => {
      });
  }
  const handleTenantChangePrice = useCallback(() => {
    dispatch(
      showPriceDialog({
        title: `工单总费(${order?.get('payer_type') === 1 ? '企业支付' : '个人支付'
          })`,
        order,
        field: 'fee',
        type: 'order',
        clickTarget: 'enterprise',
        showModalMessage: true,
        onSuccess: onSuccess
      })
    );
  }, [order]);

  const handleAddExpress = useCallback(() => {
    dispatch(
      showExpressDialog({
        title: `快递管理`,
        order,
        user: user.toJS(),
        onSuccess: onSuccess
      })
    );
  }, [order]);

  const handleAddAccessory = useCallback((accessory, order) => {
    dispatch(
      showAccessoryDetailDialog({
        title: `配件管理`,
        accessory: accessory?.toJS() || {},
        order: order.toJS(),
        user: user.toJS(),
        onSuccess: onSuccess
      })
    );
  }, [order]);


  const handleShowExpressDetail = useCallback((expressCompanyCode, expressNo, mobile) => {
    dispatch(
      showExpressDetailDialog({
        title: `快递明细-` + expressNo + '(' + expressCompanyCode + ')',
        expressCompanyCode,
        expressNo,
        mobile,
        onSuccess: onSuccess
      })
    );
  }, [order]);

  const showDeductionDialogHandler = useCallback((deduction, order_id, type, ws_id) => (event) => {
    event.stopPropagation();
    dispatch(
      showAppealDialog({
        title: '申请调价',
        order: order?.toJS(),
        appeal: deduction,
        order_id: order_id,
        onSuccess: null,
        ws_id: ws_id,
        type: type, //申请类型 0 商家申请返款 1申请对师傅扣款 2申请对商家扣款
        user: user
      })
    );
  });
  const getEvaluateInfo = useCallback((orderId) => {
    services.getEvaluateInfo({ orderId })
      .then((result) => {
        setEvaluateInfo(result.data || {})
      })
      .catch((err) => {
        message.error(err.message || '获取数据失败，请刷新重试');
      })
      .finally(() => {
      });
  });
  const getEvaluateWait = useCallback((orderId) => {
    services.getEvaluateWait({ orderId })
      .then((result) => {
        // setEvents(result)
      })
      .catch((err) => {
        message.error(err.message || '获取数据失败，请刷新重试');
      })
      .finally(() => {
      });
  });
  const fetchOrderEvent = useCallback((orderId) => {
    services.fetchOrderEvent(orderId)
      .then((result) => {
        setEvents(result)
      })
      .catch((err) => {
        message.error(err.message || '获取订单进度失败，请刷新重试');
      })
      .finally(() => {
        //setLoading(false);
      });
  });
  const findMemoAll = () => {
    services.findMemoAll({ orderId, type: 1 })
      .then((result) => {
        setServiceMemo(result.data)
      })
    services.findMemoAll({ orderId, type: 2 })
      .then((result) => {
        setBusinessMemo(result.data)
      })
    services.findMemoAll({ orderId, type: 3 })
      .then((result) => {
        setWorkerMemo(result.data)
      })

  }
  const getLabel = useCallback((event) => {
    return utils.getEventByCode(parseInt(event.event)) + ' ' + dayjs(event.time).format('YYYY-MM-DD HH:mm:ss');
  });
  const handleWorkerChangePrice = useCallback(() => {
    dispatch(
      showPriceDialog({
        title: '师傅工费单',
        order,
        field: 'worker_fee',
        type: 'order',
        onSuccess: onSuccess
      })
    );
  }, [order]);

  const handleChangeFixedPrice = useCallback(() => {
    // if (!order?.get('addr_location')) {
    //   return message.warn('请先确认上门位置');
    // }
    dispatch(
      showPriceDialog({
        title: '一口价工单',
        order,
        field: 'fee',
        type: 'fixed_price',
        // clickTarget: 'enterprise',
        onSuccess: onSuccess
      })
    );
  }, [order]);

  const getDistance = (lat1 = 0, lng1 = 0, lat2 = 0, lng2 = 0) => {
    // lat1用户的纬度
    // lng1用户的经度
    // lat2商家的纬度
    // lng2商家的经度
    if (!lat1 || !lng1 || !lat2 || !lng2) {
      return '--'
    }
    // 计算距离函数
    const Rad = (d) => {
      //根据经纬度判断距离
      return d * Math.PI / 180.0;
    }
    var radLat1 = Rad(lat1);
    var radLat2 = Rad(lat2);
    var a = radLat1 - radLat2;
    var b = Rad(lng1) - Rad(lng2);
    var s = 2 * Math.asin(Math.sqrt(Math.pow(Math.sin(a / 2), 2) + Math.cos(radLat1) * Math.cos(radLat2) * Math.pow(Math.sin(b / 2), 2)));
    s = s * 6378.137;
    s = Math.round(s * 10000) / 10000;
    s = s?.toFixed(1) + '公里' //保留两位小数
    // console.log('经纬度计算的距离:' + s)
    return s
  }
  const expressColumns = [
    {
      title: '操作人',
      dataIndex: 'user',
      key: 'user',
      render: user => <span className={styles.priceName}>
        <Avatar size="small" className={styles.avatar}
          src={user?.avatar}></Avatar>
        {user?.name}</span>,
    },
    {
      title: '快递公司',
      dataIndex: 'expressCompany',
      key: 'expressCompany',
    },
    {
      title: '运单号',
      //dataIndex: 'expressNo',
      key: 'expressNo',
      render: item => <a onClick={handleShowExpressDetail.bind(this, item.expressCompany, item.expressNo, item.mobile)}>
        {item.expressNo}</a>
    },
    {
      title: '状态',
      dataIndex: 'status',
      key: 'status',
    },

    {
      title: '描述',
      dataIndex: 'desc',
      key: 'desc',
      render: desc => <span className={styles.expressDesc}><Tooltip title={desc}>{desc}</Tooltip></span>
    },
  ];
  const accessoryColumns = [
    {
      title: '日期',
      key: 'createdAt',
      render: item => dayjs(item.createdAt).format('MM月DD日 HH:mm')
    },
    {
      title: '名称',
      dataIndex: 'name',
      key: 'name',
    },
    {
      title: '数量',
      dataIndex: 'num',
      key: 'num',
    },
    {
      title: '运单号',
      //dataIndex: 'expressNo',
      key: 'expressNo',
      render: item => <a onClick={handleShowExpressDetail.bind(this, item.expressCompany, item.expressNo, item.mobile)}>
        {item.expressNo}</a>
    },
    {
      title: '状态',
      key: 'status',
      render: item => item.expressStatus || item.status
    },
    {
      title: '描述',
      dataIndex: 'reason',
      key: 'reason',
      render: reason => <span className={styles.expressDesc}><Tooltip title={reason}>{reason}</Tooltip></span>
    },
    {
      title: '操作',
      //dataIndex: 'expressNo',
      // key: 'expressNo',
      render: item =>
        <Button
          onClick={handleAddAccessory.bind(this, item, order)}
          type="primary"
          size="small"
        >
          {item.expressNo ? '修改' : '补发'}
        </Button>
    },
  ];
  const handleWorkerServiceChangePrice = useCallback((ws) => {
    dispatch(
      showPriceDialog({
        title: '师傅工费单',
        order: fromJS(ws),
        field: 'worker_fee',
        type: 'worker_service',
        onSuccess: onSuccess
      })
    );
  });
  const handleDeduction = useCallback(() => {
    dispatch(
      deduction({
        id: orderId,
      })
    );
  }, [orderId]);
  const handleLockFee = useCallback(() => {
    dispatch(
      lockFee({
        id: orderId,
      })
    );
  }, [orderId]);

  const handleChangeServiceTime = useCallback(() => {
    dispatch(showServiceTimeDialog({ id: orderId }));
  }, [orderId]);
  const handleCloseOrder = useCallback((order) => {
    //tenant_cancel_status 商家取消状态 0未申请 1申请中 2 客服同意 3客服拒绝
    dispatch(closeOrder(orderId, { reason: order.close_reason, fee: 0 }));
  }, [orderId]);
  const handleRefuseCloseOrder = useCallback(() => {
    dispatch(refuseCloseOrder(orderId));
  }, [orderId]);
  const handleAssignWorker = useCallback(() => {
    // if (isManagerMode) {
    //   if (order?.get('fee')?.size == 0) {
    //     return message.warn('指派师傅前需要先设置企业费用-工单总费');
    //   }
    // }

    // if (!order?.get('addr_location')) {
    //   return message.warn('请先确认上门位置');
    // }
    dispatch(showAssignWorkerDialog({ title: '查看报价/指派师傅', id: orderId, orderMap: order, order: order.toJS() }));
  }, [orderId, order]);

  const handSendWorkerToUser = useCallback(() => {
    dispatch(sendWorkerToUser({ id: orderId, onSuccess: onSuccess }));
  }, [orderId, order]);

  const showProductInfoDialog = useCallback(() => {
    dispatch(
      showProductInfo({
        disabled: true,
        title: '产品详情',
        tenant_id: order?.getIn(['tenant', '_id']),
        id: order?.getIn(['product', '_id']),
      })
    );
  }, [order]);
  const showAppealDialogHandler = useCallback((appeal, id) => (event) => {
    event.stopPropagation();
    dispatch(
      showAppealDialog({
        title: '订单申诉',
        order: order?.toJS(),
        appeal: appeal?.toJS(),
        order_id: id,
        type: 0, //申请类型 0 商家申请返款 1申请对师傅扣款 2申请对商家扣款
        user: user
      })
    );
  });
  const previewImage = useCallback(async (images = [], idx) => {
    const pswpElement = document.querySelectorAll('.pswp')[0];

    const items = []
    for (let i = 0; i < images.length; i++) {
      const item = images[i]
      let w
      let h
      if (item.dimensions) {
        w = item.dimensions.width
        h = item.dimensions.height
      } else {
        const { width, height } = await getImageWidth(item.url)
        w = width
        h = height
      }
      items.push({ src: item.url, w, h })
    }
    const options = {
      index: idx,
      history: false,
      tapToClose: false,
    };
    // Initializes and opens PhotoSwipe
    const gallery = new PhotoSwipe(
      pswpElement,
      PhotoSwipeUI_Default,
      items,
      options
    );
    gallery.init();
  });
  function getImageWidth(url) {
    return new Promise(function (resolve, reject) {
      var img = new Image();
      img.src = url;
      let obj = {}
      // 如果图片被缓存，则直接返回缓存数据
      if (img.complete) {
        obj.width = img.width;
        obj.height = img.height;
        resolve(obj)
      } else {
        img.onload = function () {
          obj.width = img.width;
          obj.height = img.height;
          resolve(obj)
        }
      }
    });

  }
  //提醒师傅预约服务时间
  const remindWorker = useCallback(() => {

    dispatch(showOredrReminder({ order: order?.toJS() }))
    return
    if (isManagerMode) {
      services.remindWorkerService(order._id)
        .then((result) => {
          message.info('发送提醒成功');
          dispatch(messageActions.playActionAudio())
        })
        .catch((err) => {
          message.error(err.message || '发送提醒失败，请重试');
        })
    } else if (tenantMode) {
      services.tenantRemindWorkerService(order._id)
        .then((result) => {
          message.info('发送提醒成功');
          dispatch(messageActions.playActionAudio())
        })
        .catch((err) => {
          message.error(err.message || '发送提醒失败，请重试');
        })
    }

    // tenantRemindWorkerService
  });
  //计算师傅的订单总金额
  const calWorkerFee = useCallback((worker_fee, worker_deduction, bonus, worker_deduction_history = []) => {
    let total = 0;
    if (worker_fee) {
      total = worker_fee.reduce((t, d) => (t += (Number(d.price) || 0)), 0)
    }
    if (bonus) {
      total += bonus.coupons
    }
    // 遍历所有历史调价记录（优先使用 history，兼容旧数据使用单条 worker_deduction）
    const deductionList = (worker_deduction_history && worker_deduction_history.length > 0)
      ? worker_deduction_history
      : (worker_deduction ? [worker_deduction] : []);

    deductionList.forEach(deduction => {
      if (deduction && deduction.appeal_state == 2) {
        const appeal_type = deduction.appeal_type;
        const appeal_mount = Number(deduction.appeal_amount) || 0;
        if (appeal_type == 1) {
          total = total - appeal_mount;
        } else if (appeal_type == 2) {
          total = total + appeal_mount;
        }
      }
    });
    return total ? total.toFixed(2) : total
  });
  //计算商家的订单总金额
  const calTenantFee = useCallback((order) => {
    let total = order?.get('fee').reduce((t, d) => (t += d.get('price')), 0)
    //是否使用代金券
    if (order?.get('coupon')) {
      total = total - order?.getIn(['coupon', 'coupons'])
    }
    if (order?.get('tenant_deduction')) {
      if (order?.getIn(['tenant_deduction', 'appeal_state']) == 2) {
        const appeal_type = order?.getIn(['tenant_deduction', 'appeal_type']);
        const appeal_mount = order?.getIn(['tenant_deduction', 'appeal_amount']);
        if (appeal_type == 1) {
          total = total - appeal_mount;
        } else if (appeal_type == 2) {
          total = total + appeal_mount;
        }
      }
    }
    if (order?.get('appeal')) {
      if (order?.getIn(['appeal', 'appeal_state']) == 2) {
        const appeal_type = order?.getIn(['appeal', 'appeal_type']);
        const appeal_mount = order?.getIn(['appeal', 'appeal_amount']);
        if (appeal_type == 1) {
          total = total - appeal_mount;
        } else if (appeal_type == 2) {
          total = total + appeal_mount;
        }
      }
    }
    return Math.max(0, total)?.toFixed(2);
  });
  const calTenantFee2 = (worker_fee_total, service_fee = 0, worker_deduction, worker_deduction_history = []) => {
    let total = 0;
    if (order?.get('order_flag') == 1) {
      if (order?.get('worker')) {
        if (worker_fee_total) {
          total = worker_fee_total
        }
      }
    } else {
      if (worker_fee_total) {
        total = worker_fee_total
      }
    }
    // if (isTenantMode) {
    total += service_fee
    // }

    // 遍历所有历史调价记录（优先使用 history，兼容旧数据使用单条 worker_deduction）
    const deductionList = (worker_deduction_history && worker_deduction_history.length > 0)
      ? worker_deduction_history
      : (worker_deduction ? [worker_deduction] : []);

    deductionList.forEach(deduction => {
      if (deduction?.appeal_state == 2) {
        const num = Math.abs(deduction?.appeal_amount) || 0;
        if (deduction?.appeal_type == 1) {
          total = total - num
        } else {
          total = total + num
        }
      }
    });
    return total ? total.toFixed(2) : total
  };
  const calTenantFeeTotal = (worker_fee_total = 0, woker_services = [], worker_deduction, worker_deduction_history = []) => {
    let total = 0;
    // if (order?.get('order_flag') == 1) {
    //   // if (order?.get('worker')) {
    //     if (worker_fee_total) {
    //       total = worker_fee_total
    //     // }
    //   }
    // } else {
    //   if (worker_fee_total) {
    //     total = worker_fee_total
    //   }
    // }
    total = worker_fee_total
    woker_services.forEach(item => {
      total += item.worker_fee_total || 0

      // 遍历 WorkerService 的调价历史
      const itemDeductionList = (item.worker_deduction_history && item.worker_deduction_history.length > 0)
        ? item.worker_deduction_history
        : (item?.worker_deduction ? [item.worker_deduction] : []);

      itemDeductionList.forEach(deduction => {
        if (deduction?.appeal_state == 2) {
          const num = Math.abs(deduction?.appeal_amount) || 0;
          if (deduction?.appeal_type == 1) {
            total = total - num
          } else {
            total = total + num
          }
        }
      });
    });

    // 遍历 Order 的调价历史
    const deductionList = (worker_deduction_history && worker_deduction_history.length > 0)
      ? worker_deduction_history
      : (worker_deduction ? [worker_deduction] : []);

    deductionList.forEach(deduction => {
      if (deduction?.appeal_state == 2) {
        const num = Math.abs(deduction?.appeal_amount) || 0;
        if (deduction?.appeal_type == 1) {
          total = total - num
        } else {
          total = total + num
        }
      }
    });

    return total ? total.toFixed(2) : total
  };
  const showAdjustPriceText = useCallback((appeal_state) => {
    let text = ''
    if (appeal_state == 2) {
      //if(order?.getIn([key,'appeal_state'])==2){
      text += '查看'
    } else {
      if (user.get('isTouer')) {
        text += '确认'
      } else {
        text += '申请'
      }
    }
    text += '调价'
    return text
  });
  const shareImg = useCallback(
    (url) => (event) => {
      event.stopPropagation();
      dispatch(
        sendMessage({
          order_id: order?.get('_id'),
          message_type: 'image',
          image: url,
        })
      );
      // sendMessage
    },
    [order]
  );

  const showOrderPreview = useCallback(
    (e) => {
      e.preventDefault();
      if (!order || !order?.get('prev_order')) return;

      // TODO 先关闭之前的弹出框，再打开
      dispatch(
        orderPreview({
          title: `${order?.get('order_no')} 的前置工单`,
          id: order?.getIn(['prev_order', '_id']),
        })
      );
    },
    [order]
  );
  const showAssignDialogHandler = useCallback(() => {
    dispatch(
      orderActions.showAssignDialog({
        title: '指给客服',
        id: orderJs._id,
      })
    );
  });
  const showEditOrderDialog = useCallback((user) => {
    dispatch(
      showCreateOrderDialog({
        title: `修改工单 ${order.order_no} - ${order.payer_type === 1 ? '保内' : '保外'
          } - ${status.text}`,
        editMode: true,
        user,
        order: orderJs,
        dispatch
      })
    );
  }, [order]);

  const history = useHistory();
  const nav2Conv = useCallback((event) => {
    event.stopPropagation();
    history.push(`/workspace`, { order: order?.get('_id') });

    if (props.hide) {
      setTimeout(() => {
        props.hide();
      }, 600);
    }
  }, [order]);
  const onSuccess = useCallback(() => {
    dispatch(fetchOrder(orderId));
  });
  const payForWorker = useCallback((id) => {
    apis.payForWorker(id).then(result => {
      message.success('提交成功')
      dispatch(fetchOrder(orderId));
    }).catch(err => {
      message.error(err.message || '发生错误')
    }).finally(() => {
    })
  });

  const submitMemo = () => {
    if (!memoValue) {
      return message.info('请输入备注信息')
    }
    // 客服备注历史：1，商家备注历史：2，师傅备注历史：3
    let type = 1
    if (isManagerMode) {
      type = 1
    } else if (tenantMode) {
      type = 2
    }
    const datas = {
      orderId: orderId,
      memo: memoValue,
      type: type
    }
    services.addMemo2(datas).then(result => {
      message.success('提交成功')
      setMemoValue('')
      findMemoAll(orderId)
    }).catch(err => {
      message.error(err.message || '发生错误')
    }).finally(() => {
    })
  }

  useUpdateEffect(() => {
    // 异步更新 当前order的信息
    if (orderId && prevOrderId !== orderId) {
      if ($scrollEl.current) {
        $scrollEl.current.scrollTop = 0;
      }
    }
  });
  useEffect(() => {
    if (orderId) {
      getEvaluateInfo(orderId);
      getEvaluateWait(orderId);
      fetchOrderEvent(orderId);
      findMemoAll(orderId)
      getOrderWaitOp(orderId)
    }
  }, [orderId]);

  useEffect(() => {
    if (orderId) {
      getEvaluateInfo(orderId);
    }
  }, [order]);

  useMount(() => {
    if (orderId && forceSync) {
      dispatch(fetchOrder(orderId));
    }
    if (orderId) {
      getOrderWaitOp(orderId)
    }

  });
  if (!order || !order?.get('_id')) {
    return null;
  }

  // console.log('order:', order.toJS());

  return (
    <div className={styles.containerwrap} id="order-detail-wrap">
      <div className={styles.container}>
        <div className={styles.workorder}>
          <div className={styles.workerwrap}>
            <div className={styles.userinfo}>
              <div className={styles.avatar}>
                <img className={styles.avatarimg} src={order?.getIn(['createdBy', 'avatar'])} />

              </div>
              <div className={styles.name}>{order?.getIn(['createdBy', 'name'])}
                {!order?.get('is_retail') && <TenantStatusBadge order={orderJs} style={{ marginLeft: 10 }} />}
              </div>
            </div>
            <div className={styles.time}>创建时间：{dayjs(order?.get('createdAt')).format("YYYY-MM-DD HH:mm")}</div>
          </div>
          <div className={styles.workorderinfo}>
            <div className={styles.pic}>
              {order?.get('is_retail') ?
                <AlbumPreviewCover url={order?.getIn(['images', 0])} /> :
                <AlbumPreviewCover url={order?.getIn(['product_list', 0, 'images', 0, 'url'])} />
              }
            </div>
            <div className={styles.workorderinforight}>
              <div className={styles.itemtitle}>
                <div className={styles.titletext}>{order?.getIn(['product_list', 0, 'name'])}</div>
                <div className={styles.titleorther}>
                  {!readOnly && order?.get('status_code') < orderStatus.DONE &&
                    <Button
                      onClick={showEditOrderDialog.bind(this, user)}
                      // disabled={!orderReceived}
                      type="link" icon="edit"
                      style={{ marginLeft: 10 }}
                      size="small"
                    >
                      修改工单
                    </Button>
                  }
                </div>
              </div>

              <div className={styles.itemtags}>
                {order?.get('order_flag') == 1 && <StatusBadge style={{ background: '#FF3232' }}>
                  一口价
                </StatusBadge>}
                <StatusBadge style={status.style}>
                  {status.text}{(order?.get('is_guaqi') && order?.get('status_code') <= orderStatus.WORKER_LOCATION_CHECKED) ? ' | 挂起' : ''}
                </StatusBadge>
                {order?.get('is_urgent') && <StatusBadge style={{ color: '#FF6600', background: '#FFE6D5' }}>
                  急单
                </StatusBadge>}
                {order?.get('order_type') == 1 && <StatusBadge style={{ color: '#0787FF', background: '#D7EAFF' }}>
                  安装
                </StatusBadge>}
                {order?.get('order_type') == 2 && <StatusBadge style={{ color: '#D68F00', background: '#FFF0BE' }}>
                  维修
                </StatusBadge>}
                {order?.get('payer_type') == 1 && <StatusBadge style={{ color: '#009C4B', background: '#D1EBCE' }}>
                  保内
                </StatusBadge>}
                {order?.get('payer_type') == 2 && <StatusBadge style={{ color: '#FF731B', background: '#FFE6D5' }}>
                  保外
                </StatusBadge>}
                {order?.get('is_arrival') && <StatusBadge style={{ color: '#009C4B', background: '#D1EBCE' }}>
                  已到货
                </StatusBadge>}
              </div>

              <div className={styles.itemdesc}>
                <div className={styles.descitem}>订单号：{order?.get('order_no') || order?.get('order_id')}</div>
                <div className={styles.descitem}>预约时间：{order?.get('service_time') ? dayjs(order?.get('service_time')).format("YYYY-MM-DD HH:mm") : ''}</div>
              </div>
              <div className={styles.itemdesc} style={{ marginTop: '5px' }}>
                <div className={styles.descitem}>工单号：{order?.get('order_number') || ""}</div>
              </div>
            </div>
          </div>
        </div>


        <div ref={$scrollEl}>
          <Tabs defaultActiveKey="1"
            tabBarStyle={{ border: '1px solid #177C48', borderRadius: '4px', color: '#333' }}
          >
            <TabPane tab="基本信息" key="1">
              <OrderNotice orderId={orderId} order={order} />

              {
                (
                  (
                    isManagerMode ||
                    (tenantMode && order?.get('ticket_type') == 1)
                  ) &&
                  !order?.get('is_retail')
                ) && <div>
                  <SectionTitle
                    title={
                      <>
                        <span>工单总费 (</span>
                        <span>
                          {order?.get('payer_type') === 2 ? <span style={{ color: 'red' }}>客户支付</span> : '企业支付'}
                        </span>
                        <span>)</span>
                        {!order?.get('is_retail') && <span>
                          <TenantStatusBadge order={orderJs} style={{ marginLeft: 10, verticalAlign: 'middle' }} />
                        </span>}
                      </>
                    }
                  >
                    <>

                      {!readOnly &&
                        !tenantMode &&
                        !platformChecked &&
                        isActive &&
                        !order?.get('isPaid') &&
                        !order?.get('workerFeePaid') && (
                          <>
                            {/* {
                            // order?.get('payer_type') === 1 &&
                            order?.get('fee').size !== 0 && !order?.get('fee_locked') && (
                              <Button
                                type="primary"
                                style={{ marginLeft: 10 }}
                                onClick={handleLockFee}
                                size="small"
                              >
                                {order?.get('status_code') ===
                                  orderStatus.LOCK_FEE_FAILD
                                  ? '重试锁定'
                                  : '锁定'}
                              </Button>
                            )
                          } */}
                            <Button
                              type={order?.get('payer_type') === 2 ? "danger" : "primary"}
                              style={{ marginLeft: 10 }}
                              onClick={handleTenantChangePrice}
                              size="small"
                            >
                              {order?.get('payer_type') === 2 ? '保外价格' : '改价'}
                            </Button>

                          </>
                        )
                      }
                      {/* {!tenantMode && (order?.get('status_code') == 5001 || order?.get('status_code') == 6001 ||
                      order?.get('status_code') == 6002) && ((user.get('isTouer') && order?.get('tenant_deduction')) || !user.get('isTouer')
                      ) &&
                      <Button
                        type={order?.getIn(['tenant_deduction', 'appeal_state']) == 2 ? "default" : "primary"}
                        style={{ marginLeft: 10 }}
                        onClick={showDeductionDialogHandler(orderJs.tenant_deduction, order._id, 2, null)}
                        size="small">
                        {showAdjustPriceText(order?.getIn(['tenant_deduction', 'appeal_state']))}
                      </Button>
                    } */}
                    </>
                  </SectionTitle>
                  <OrderRow title="企业费用合计：">
                    <span className={styles.textcolor1} >
                      {order?.get('fee_total') ? order?.get('fee_total')?.toFixed(2) : 0}元
                      {/* {calTenantFee(order)}元 */}
                      {(order?.get('fee_locked') && order?.get('payer_type') !== 2) && (
                        <span style={{ fontSize: 12, color: '#777' }}>
                          （已从
                          {order?.get('fee_locked_from') === 1 ? '信用额度' : '余额'}
                          冻结）
                        </span>
                      )}

                      {order?.get('tenant_confirm_fee') == 3 && <span style={{ fontSize: 12, marginLeft: 5, color: 'red' }}>
                        冻结资金失败，需充值以指派师傅。
                      </span>}
                    </span>
                  </OrderRow>
                  <OrderRow title="企业费用明细：">
                    <div className={styles.priceList}>
                      {order?.get('fee') &&
                        order?.get('fee').map((item, index) => {
                          return (
                            <div className={styles.priceItem} key={index}>
                              <span className={styles.priceName}>{item?.get('name')}</span>
                              <span className={styles.priceVal}>{item?.get('price') ? item?.get('price')?.toFixed(2) : item?.get('price')}</span>
                            </div>
                          );
                        })
                      }
                      {
                        order?.get('tenant_deduction_history') && order?.get('tenant_deduction_history')?.map(item => {
                          return <>
                            {item?.get && item?.get('appeal_state') == 2 ? (
                              <div className={styles.priceItem}>
                                <span className={styles.priceName}>{item?.getIn(['appeal_type']) == 1 ? '客服下调' : '客服上调'}</span>
                                <span className={styles.priceVal}>{item?.getIn(['appeal_amount'])}</span>
                                <span>（{item?.getIn(['appeal_reason'])}）</span>
                              </div>
                            ) : null}
                          </>
                        })
                      }
                      {
                        order?.get('appeal_history') && order?.get('appeal_history')?.map(item => {
                          return <>
                            {item?.get && item?.get('appeal_state') == 2 ? (
                              <div className={styles.priceItem}>
                                <span className={styles.priceName}>{item?.getIn(['appeal_type']) == 1 ? '申诉下调' : '申诉上调'}</span>
                                <span className={styles.priceVal}>{item?.getIn(['appeal_amount'])}</span>
                                <span>（{item?.getIn(['appeal_reason'])}）</span>
                              </div>
                            ) : null}
                          </>
                        })
                      }
                      {
                        order?.get('coupon') && (
                          <div className={styles.priceItem}>
                            <span className={styles.priceName}>{'代金券抵扣'}</span>
                            <span className={styles.priceVal}>{order?.getIn(['coupon', 'coupons'])}</span>
                          </div>
                        )
                      }
                      {order?.get('ticket_type') == 2 && <div className={styles.priceItem} style={{
                        width: '100%',
                        justifyContent: 'flex-start'
                      }}>
                        <span className={styles.priceName}>平台服务费</span>
                        <span className={styles.priceVal}>{order?.get('fee_service') ? order?.get('fee_service')?.toFixed(2) : 0}</span>
                      </div>}
                      {/* {!order?.get('fee') ||
                    (order?.get('fee').size === 0 && (
                      <Empty
                        description="还未记录"
                        image={Empty.PRESENTED_IMAGE_SIMPLE}
                      ></Empty>
                    ))} */}
                    </div>
                  </OrderRow>
                </div>
              }

              {
                order?.get('is_retail') && <div>
                  <SectionTitle title={<span>订单信息</span>} >
                  </SectionTitle>
                  <OrderRow title="服务内容">{order?.get('order_name') || ''}</OrderRow>
                  <OrderRow title="物品数量">{order?.get('item_quantity') || 0}</OrderRow>
                  <OrderRow title="期望价格">{order?.get('expected_price') || 0}元</OrderRow>
                  <OrderRow title="期望上门时间">
                    {order?.get('service_time') ? dayjs(order?.get('service_time')).format('YYYY-MM-DD HH:mm') : ''}
                  </OrderRow>
                  <OrderRow title="需求说明">{order?.get('desc') || ''}</OrderRow>
                  <OrderRow title="图片">
                    <div style={{ padding: '5px 0' }}>
                      <AlbumPreview urls={order?.get('images') || []} />
                    </div>
                  </OrderRow>

                </div>
              }

              {(isManagerMode || (
                tenantMode
                // &&
                // order?.get('ticket_type') == 2
              )) &&
                <div>
                  <SectionTitle title={<>
                    {(!tenantMode || order?.get('ticket_type') == 2) &&
                      <span>
                        师傅费用

                      </span>
                    }
                    {(tenantMode) &&
                      <span>服务信息</span>
                    }
                    {!order?.get('is_retail') && <TenantStatusBadge order={orderJs} style={{ marginLeft: 10, verticalAlign: 'middle' }} />}
                  </>}>
                    <>

                      {/* {!readOnly &&
                      isActive &&
                      !order?.get('workerFeePaid') &&
                      !platformChecked && (<>
                        <Button
                          type="primary"
                          style={{ marginLeft: 10 }}
                          onClick={handleWorkerChangePrice}
                          size="small"
                        >
                          改价
                        </Button>
                      </>
                      )} */}
                      {/* {(order?.get('status_code') == 5001 || order?.get('status_code') == 6001 ||
                      order?.get('status_code') == 6002) &&
                      ((user.get('isTouer') && order?.get('worker_deduction')) || !user.get('isTouer'))
                      && <Button
                        type={order?.getIn(['worker_deduction', 'appeal_state']) == 2 ? "default" : "primary"}
                        style={{ marginLeft: 10 }}
                        onClick={showDeductionDialogHandler(orderJs.worker_deduction, order._id, 1, null)}
                        size="small">
                        {showAdjustPriceText(order?.getIn(['worker_deduction', 'appeal_state']))}
                      </Button>} */}
                    </>
                  </SectionTitle>
                  {/* <OrderRow title="师傅费用合计：">
                  <span className={styles.textcolor1}>
                    {calWorkerFee(orderJs.worker_fee, orderJs.worker_deduction, orderJs.bonus)}元
                  </span>
                </OrderRow> */}
                  {(!tenantMode || order?.get('ticket_type') == 2) &&
                    <OrderRow title="师傅费用合计：">
                      <span className={styles.textcolor1}>
                        {calTenantFeeTotal(
                          order?.get('worker_fee_total'),
                          order?.get('worker_services')?.toJS(),
                          order?.get('worker_deduction')?.toJS(),
                          order?.get('worker_deduction_history')?.toJS()
                        )}元
                      </span>
                    </OrderRow>
                  }
                  {/* <OrderRow title="师傅费用明细：">
                  <div className={styles.priceList}>
                    {order?.get('worker_fee') &&
                      order?.get('worker_fee').map((item, index) => {
                        return (
                          <div className={styles.priceItem} key={index}>
                            <span className={styles.priceName}>{item.get('name')}</span>
                            <span className={styles.priceVal}>{item.get('price') ? Math.round(item.get('price'), 2) : item.get('price')}</span>
                          </div>
                        );
                      })}
                    {order?.get('bonus') && (
                      <div className={styles.priceItem}>
                        <span className={styles.priceName}>奖金券</span>
                        <span className={styles.priceVal}>{order?.getIn(['bonus', 'coupons'])}</span>
                      </div>
                    )}
                    {
                      order?.get('worker_deduction') && (order?.getIn(['worker_deduction', 'appeal_state']) == 2) && (
                        <div className={styles.priceItem}>
                          <span className={styles.priceName}>{order?.getIn(['worker_deduction', 'appeal_type']) == 1 ? '客服下调' : '客服上调'}</span>
                          <span className={styles.priceVal}>{order?.getIn(['worker_deduction', 'appeal_amount'])}</span>
                        </div>
                      )
                    }
                  </div>
                </OrderRow> */}
                  <Collapse defaultActiveKey={["last"]} >
                    {woker_services.map((ws, index) => {
                      return (
                        <Panel header={`第${index + 1}次上门`} key={index + 1}>
                          {ws.reason &&
                            <OrderRow title="上门原因">
                              {ws.reason}
                            </OrderRow>
                          }
                          {ws.service_time &&
                            <OrderRow title="预约时间">
                              {dayjs(ws.service_time).format('YYYY-MM-DD HH:mm')}
                            </OrderRow>
                          }
                          {(!tenantMode || user.getIn(['staff', 'tenant', 'show_worker_tel']) === 1) && (
                            <OrderRow title="指派师傅">
                              <div
                                style={{ marginRight: 10, display: 'flex', alignItems: 'center' }}
                              >
                                <Avatar
                                  size="small"
                                  className={styles.avatar}
                                  src={ws.worker?.user?.avatar}
                                />
                                <span style={{ marginRight: 10, marginRight: 10 }}>
                                  {ws.worker?.realname}
                                </span>
                                <CallNumber number={ws.worker?.user?.mobile} />
                              </div>
                            </OrderRow>)}
                          {ws.worker_completed_at && <OrderRow title="师傅完单">
                            {dayjs(ws.worker_completed_at).format('YYYY-MM-DD HH:mm') + ((ws.is_captcha) ? '(使用验证码)' : '(无验证码)')}
                          </OrderRow>
                          }
                          {ws.platform_checked_at &&
                            <OrderRow title="客服确认">
                              {dayjs(ws.platform_checked_at).format('YYYY-MM-DD HH:mm')}
                            </OrderRow>}
                          {!tenantMode && <OrderRow title="是否结算">
                            {ws.workerFeePaid ? '已结算' : (<>未结算 {isActive &&
                              <Popconfirm
                                title="是否提前给师傅结算?"
                                onConfirm={payForWorker.bind(this, ws._id)}
                                okText="确定"
                                cancelText="取消" >
                                <Button style={{ marginLeft: 10 }} type="primary" size="small">结算</Button>
                              </Popconfirm>}
                            </>)}
                          </OrderRow>}

                          <OrderRow title={(<>完单图片<br />反馈要求</>)}>
                            {order?.get('feedback_demand')}
                          </OrderRow>

                          <OrderRow title="店铺名称">
                            {order?.get('order_source')}
                          </OrderRow>
                          <OrderRow title="处理结果">
                            {order?.get('workerResult')}
                          </OrderRow>
                          <OrderRow title={(<>超时未<br />上门原因</>)}>
                            {order?.get('timeOut')}
                          </OrderRow>
                          {ws.feedback_images?.length !== 0 && (
                            <div>
                              <SectionTitle title="师傅反馈照片"></SectionTitle>
                              <div className={styles.photoBox}>
                                <div className={styles.photoList}>
                                  {ws.feedback_images?.length === 0 && (
                                    <center style={{ width: '100%' }}>
                                      <Empty
                                        description="暂无反馈"
                                        image={Empty.PRESENTED_IMAGE_SIMPLE}
                                      ></Empty>
                                    </center>
                                  )}
                                  {ws.feedback_images?.map((item, idx) => (
                                    <div
                                      key={idx}
                                      onClick={() => previewImage(ws.feedback_images, idx)}
                                      className={styles.photoItem}
                                    >
                                      <Tooltip title={item.desc}>
                                        <img
                                          alt=""
                                          className={styles.photoImage}
                                          src={item.url}
                                        />
                                      </Tooltip>
                                      {/* <div style={{ textAlign: 'center' }}>
                                      <Tooltip title="转发到会话">
                                        <span
                                          onClick={shareImg(item.url)}
                                          className={cn('iconfont', styles.shareImgBtn)}
                                        >
                                          &#xe6e7;
                                        </span>
                                      </Tooltip>
                                    </div> */}
                                      <div className={styles.photoTime}>
                                        {dayjs(item.createdAt).fromNow()}
                                      </div>
                                    </div>
                                  ))}
                                </div>
                              </div>
                            </div>
                          )}
                          {orderReceived && (!tenantMode || order?.get('ticket_type') == 2) && (
                            <div>
                              <SectionTitle title={<>
                                <span>师傅工费单</span>
                                {!order?.get('is_retail') && <TenantStatusBadge order={orderJs} style={{ marginLeft: 10, verticalAlign: 'middle' }} />}
                              </>}>
                                <>
                                  <span style={{ marginLeft: 10, fontSize: 12, color: '#777' }}>
                                    合计：
                                    {calTenantFee2(ws.worker_fee_total, 0, ws?.worker_deduction || {}, ws?.worker_deduction_history || [])}元
                                  </span>

                                  {!readOnly &&
                                    isActive &&
                                    !ws.workerFeePaid &&
                                    !ws.platform_checked && (<>
                                      {(isManagerMode || (tenantMode && order?.get('ticket_type') != 2)) && <Button
                                        type="primary"
                                        style={{ marginLeft: 10 }}
                                        onClick={handleWorkerServiceChangePrice.bind(this, ws)}
                                        size="small"
                                      >
                                        改价
                                      </Button>}
                                    </>
                                    )}

                                  {/* {(order?.get('status_code') == 5001 || order?.get('status_code') == 6001 ||
                                    order?.get('status_code') == 6002) &&
                                    ((user.get('isTouer') && ws.worker_deduction) || !user.get('isTouer'))
                                    && <Button
                                      type={ws.worker_deduction?.appeal_state == 2 ? "default" : "primary"}
                                      style={{ marginLeft: 10 }}
                                      onClick={showDeductionDialogHandler(ws.worker_deduction, order._id, 1, ws._id)}
                                      size="small">
                                      {showAdjustPriceText(ws.worker_deduction?.appeal_state)}
                                    </Button>} */}
                                </>
                              </SectionTitle>
                              <div className={styles.priceList}>
                                {ws.worker_fee &&
                                  ws.worker_fee.map((item, indx) => {
                                    return (
                                      <div className={styles.priceItem} key={indx}>
                                        <span className={styles.priceName}>{item.name}</span>
                                        <span className={styles.priceVal}>{item.price}</span>
                                      </div>
                                    );
                                  })}
                                {ws.bonus && (
                                  <div className={styles.priceItem}>
                                    <span className={styles.priceName}>奖金券</span>
                                    <span className={styles.priceVal}>{ws.bonus.coupons}</span>
                                  </div>
                                )}
                                {(() => {
                                  // 兼容 WorkerService 的历史调价显示
                                  const deductionList = (ws.worker_deduction_history && ws.worker_deduction_history.length > 0)
                                    ? ws.worker_deduction_history
                                    : (ws.worker_deduction ? [ws.worker_deduction] : []);

                                  return deductionList.map((deduction, idx) => {
                                    // 兼容 Immutable 对象和普通 JS 对象
                                    const appeal_state = deduction.get ? deduction.get('appeal_state') : deduction.appeal_state;
                                    const appeal_type = deduction.get ? deduction.get('appeal_type') : deduction.appeal_type;
                                    const appeal_amount = deduction.get ? deduction.get('appeal_amount') : deduction.appeal_amount;
                                    const appeal_reason = deduction.get ? deduction.get('appeal_reason') : deduction.appeal_reason;

                                    if (appeal_state == 2) {
                                      return (
                                        <div className={styles.priceItem} key={'ws_deduction_' + idx}>
                                          <span className={styles.priceName}>{appeal_type == 1 ? '客服下调' : '客服上调'}</span>
                                          <span className={styles.priceVal}>{appeal_amount}</span><span style={{ marginLeft: "10px" }}>{appeal_reason}</span>
                                        </div>
                                      )
                                    }
                                    return null;
                                  });
                                })()}
                                <br />
                                <div className={styles.priceItem} style={{ width: '100%', justifyContent: 'flex-start' }}>
                                  <span className={styles.priceName}>平台服务费</span>
                                  <span className={styles.priceVal}>{ws.worker_fee_service ? ws.worker_fee_service?.toFixed(2) : 0}</span>
                                </div>
                                {!ws.worker_fee ||
                                  (ws.worker_fee.length === 0 && (
                                    <Empty
                                      description="还未记录"
                                      image={Empty.PRESENTED_IMAGE_SIMPLE}
                                    ></Empty>
                                  ))}
                              </div>
                            </div>
                          )}
                        </Panel>
                      )
                    })}
                    <Panel header={`第${order?.get('worker_services')?.size + 1}次上门`} key="last">
                      {order?.get('reason') &&
                        <OrderRow title="上门原因">
                          {order?.get('reason')}
                        </OrderRow>
                      }
                      <OrderRow title="预约时间">
                        {order?.get('service_time')
                          ? dayjs(order?.get('service_time')).format('YYYY-MM-DD HH:mm')
                          : '待预约'}
                        {/* {!readOnly && !tenantMode && orderReceived && !workerCompleted && (
                        <Button
                          type="default"
                          style={{ marginLeft: 10 }}
                          onClick={handleChangeServiceTime}
                          size="small"
                        >
                          更改
                        </Button>
                      )} */}
                      </OrderRow>
                      {

                        // !!(order?.get('fee') && order?.get('fee')?.size) &&
                        (!tenantMode || (order?.get('ticket_type') == 2 && order?.get('status_code') < 6002)) &&
                        (
                          <OrderRow title="指派师傅">
                            {order?.get('worker') ? (
                              <div
                                style={{ marginRight: 2, display: 'flex', alignItems: 'center' }}
                              >
                                <Avatar
                                  size="small"
                                  className={styles.avatar}
                                  src={order?.getIn(['worker', 'user', 'avatar'])}
                                />
                                <span style={{ marginRight: 2, marginRight: 2 }}>
                                  {order?.getIn(['worker', 'realname'])}
                                </span>
                                <CallNumber number={order?.getIn(['worker', 'user', 'mobile'])} />
                              </div>
                            ) : (
                              <div style={{ marginRight: 2, color: '#cecece' }}>未指派</div>
                            )}
                            {/* {!readOnly &&
                          !workerCompleted &&
                          (order?.get('worker') || order?.get('fee_locked')) && (
                            <>
                              <Button
                                type={!order?.get('worker') ? 'primary' : 'default'}
                                onClick={handleAssignWorker}
                                size="small"
                              >
                                {order?.get('worker') ? '更换' : '指派'}
                              </Button>

                            </>
                          )
                        } */}
                            {order?.get('worker') &&
                              <Button type="default" size="small" style={{ marginLeft: 2 }} disabled={order?.get('is_notify')}
                                onClick={handSendWorkerToUser}>{order?.get('is_notify') ? "已通知" : "通知用户"}</Button>
                            }
                          </OrderRow>
                        )}
                      {order?.get('worker_completed_at') && (
                        <OrderRow title="师傅完单">
                          {dayjs(order?.get('worker_completed_at')).format('YYYY-MM-DD HH:mm') + (order?.get('is_captcha') ? '(使用验证码)' : '(无验证码)')}
                        </OrderRow>
                      )
                      }
                      {order?.get('platform_checked_at') && (
                        <OrderRow title="客服确认">
                          {dayjs(order?.get('platform_checked_at')).format('YYYY-MM-DD HH:mm')}
                        </OrderRow>
                      )}
                      {!tenantMode && order?.get('status_code') >= 5001 && (<OrderRow title="是否结算">
                        {order?.get('workerFeePaid') ? '已结算' : '未结算'}
                      </OrderRow>
                      )}

                      <OrderRow title={(<>完单图片<br />反馈要求</>)}>
                        {order?.get('feedback_demand')}
                      </OrderRow>

                      <OrderRow title="店铺名称">
                        {order?.get('order_source')}
                      </OrderRow>
                      <OrderRow title="处理结果">
                        {order?.get('workerResult')}
                      </OrderRow>
                      <OrderRow title={(<>超时未<br />上门原因</>)}>
                        {order?.get('timeOut')}
                      </OrderRow>
                      {order?.get('feedback_images') && order?.get('feedback_images')?.size !== 0 && (
                        <div>
                          <SectionTitle title="师傅反馈照片"></SectionTitle>
                          <div className={styles.photoBox}>
                            <div className={styles.photoList}>
                              {order?.get('feedback_images')?.size === 0 && (
                                <center style={{ width: '100%' }}>
                                  <Empty
                                    description="暂无反馈"
                                    image={Empty.PRESENTED_IMAGE_SIMPLE}
                                  ></Empty>
                                </center>
                              )}
                              {order?.get('feedback_images')?.map((item, idx) => (
                                <div
                                  key={idx}
                                  onClick={() => previewImage(orderJs.feedback_images, idx)}
                                  className={styles.photoItem}
                                >
                                  <Tooltip title={item?.get('desc')}>
                                    <img
                                      alt=""
                                      className={styles.photoImage}
                                      src={item?.get('url')}
                                    />
                                  </Tooltip>
                                  {/* <div style={{ textAlign: 'center' }}>
                                  <Tooltip title="转发到会话">
                                    <span
                                      onClick={shareImg(item.get('url'))}
                                      className={cn('iconfont', styles.shareImgBtn)}
                                    >
                                      &#xe6e7;
                                    </span>
                                  </Tooltip>
                                </div> */}
                                  <div className={styles.photoTime}>
                                    {dayjs(item?.get('createdAt')).fromNow()}
                                  </div>
                                </div>
                              ))}
                            </div>
                          </div>
                        </div>
                      )}

                      {(!tenantMode || order?.get('ticket_type') == 2) && <div>
                        <SectionTitle title={<>
                          <span>师傅工费单</span>
                          {!order?.get('is_retail') && <TenantStatusBadge order={orderJs} style={{ marginLeft: 10, verticalAlign: 'middle' }} />}
                        </>}>
                          <>
                            <span style={{ marginLeft: 10, fontSize: 12, color: '#777' }}>
                              合计：
                              {calTenantFee2(order?.get('worker_fee_total'), 0, order?.get('worker_deduction')?.toJS(), order?.get('worker_deduction_history')?.toJS())}元
                            </span>

                            {!readOnly &&
                              isActive &&
                              !order?.get('workerFeePaid') &&
                              !order?.get('platform_checked') && (<>
                                {(isManagerMode || (tenantMode && order?.get('ticket_type') != 2)) && <Button
                                  type="primary"
                                  style={{ marginLeft: 10 }}
                                  onClick={handleWorkerServiceChangePrice.bind(this, order)}
                                  size="small"
                                >
                                  改价
                                </Button>}
                              </>
                              )}
                          </>
                        </SectionTitle>
                        <div className={styles.priceList}>
                          {order?.get('worker_fee') &&
                            order?.get('worker_fee').map((item, indx) => {
                              return (
                                <div className={styles.priceItem} key={indx}>
                                  <span className={styles.priceName}>{item?.get('name')}</span>
                                  <span className={styles.priceVal}>{item?.get('price')}</span>
                                </div>
                              );
                            })}
                          <br />
                          <div className={styles.priceItem} style={{ width: '100%', justifyContent: 'flex-start' }}>
                            <span className={styles.priceName}>平台服务费</span>
                            <span className={styles.priceVal}>{order?.get('worker_fee_service') ? order?.get('worker_fee_service')?.toFixed(2) : 0}</span>
                          </div>

                          {(() => {
                            const deductionList = (order?.get('worker_deduction_history') && order?.get('worker_deduction_history')?.size > 0)
                              ? order?.get('worker_deduction_history')
                              : (order?.get('worker_deduction') ? List([order?.get('worker_deduction')]) : List());

                            return deductionList.map((deduction, idx) => {
                              // 兼容 Immutable 对象和普通 JS 对象
                              const appeal_state = deduction.get ? deduction.get('appeal_state') : deduction.appeal_state;
                              const appeal_type = deduction.get ? deduction.get('appeal_type') : deduction.appeal_type;
                              const appeal_amount = deduction.get ? deduction.get('appeal_amount') : deduction.appeal_amount;
                              const appeal_reason = deduction.get ? deduction.get('appeal_reason') : deduction.appeal_reason;

                              if (appeal_state == 2) {
                                return (
                                  <div className={styles.priceItem} key={'deduction_' + idx}>
                                    <span className={styles.priceName}>{appeal_type == 1 ? '客服下调' : '客服上调'}</span>
                                    <span className={styles.priceVal}>{appeal_amount}</span> <span style={{ marginLeft: '10px' }}>({appeal_reason})</span>
                                  </div>
                                )
                              }
                              return null;
                            });
                          })()}
                        </div>
                      </div>}
                    </Panel>
                  </Collapse>
                </div>
              }

              <div>
                <SectionTitle title="客户信息">
                  <Button
                    type="primary"
                    style={{ marginLeft: 10 }}
                    size="small"
                    onClick={() => {
                      const copyText = [
                        `商家名: ${order?.getIn(['tenant', 'short_name']) || ''}`,
                        `派单人: ${order?.getIn(['tenantAssignTo', 'name']) || ''}`,
                        `产品名称型号: ${order?.getIn(['product_list', 0, 'name']) || ''}`,
                        `产品数量: ${order?.getIn(['product_list'])?.size || ''}`,
                        `技术电话: ${order?.getIn(['tech_mobile']) || ''}`,
                        `物流电话: ${order?.getIn(['logistics_mobile']) || ''}`,
                        `客户姓名: ${order?.getIn(['contact_name']) || ''}`,
                        `客户电话: ${order?.get('contact_mobile') || ''}`,
                        `客户地址: ${(order?.get('address') || '') + (order?.get('addr_detail') || '')}`,
                        `服务内容: ${order?.get('desc') || ''}`,
                        `完单图片反馈要求: ${order?.get('feedback_demand') || ''}`,
                      ]
                      copy(copyText.map(item => item).join('\n'));
                      message.success("复制成功")
                    }}
                  >
                    一键复制
                  </Button>
                </SectionTitle>
                <OrderRow title="客户姓名">
                  <div style={{ lineHeight: '26px' }}>
                    {/* {
                      <Avatar
                        shape="circle"
                        size="small"
                        className={styles.avatar}
                        src={order?.getIn(['createdBy', 'avatar'])}
                      />
                    } */}
                    <span style={{ marginRight: 10 }}>
                      {order?.getIn(['contact_name'])}
                    </span>
                  </div>
                </OrderRow>
                <OrderRow title="联系电话">
                  <CallNumber show number={order?.get('contact_mobile')} />
                  {order?.get('worker') &&
                    (<Button type="link" icon="message"
                      disabled={order?.get('is_notify')}
                      onClick={handSendWorkerToUser}
                    >
                      {order?.get('is_notify') ? "已通知" : (tenantMode ? '将师傅电话发送给客户' : "发送消息")}
                    </Button>)
                  }
                </OrderRow>
                <OrderRow title="客户地址">
                  <MapDialog
                    readOnly={readOnly}
                    address={order?.get('address') + (order?.get('addr_detail') || '')}
                    location={
                      order?.get('addr_location')
                        ? orderJs.addr_location
                        : null
                    }
                    orderId={order?.get('_id')}
                    ticketType={order?.get('ticket_type')}
                  >
                    <div className={styles.addrBox}>
                      <span className={styles.addr}>{order?.get('address') + (order?.get('addr_detail') || '')}</span>
                      <span className={styles.addrLink}>
                        <i className={cn('iconfont', styles.icon)}>&#xe652;</i>
                      </span>
                      {!tenantMode && !order?.get('addr_location') && (
                        <span style={{ color: '#DA5035', fontWeight: 'bold' }}>
                          {' '}
                          (未确认)
                        </span>
                      )}
                    </div>
                  </MapDialog>
                </OrderRow>
              </div>

              {
                order?.get('worker') && <div>
                  <SectionTitle title="师傅信息"></SectionTitle>
                  <div className={styles.workerinfowrap}>
                    {order?.get('stag') === 1 && <img className={styles.workertag} src="/images/worker-tag1.png" />}
                    {order?.get('stag') === 2 && <img className={styles.workertag} src="/images/worker-tag2.png" />}
                    {order?.get('stag') === 3 && <img className={styles.workertag} src="/images/worker-tag3.png" />}
                    {order?.get('stag') === 4 && <img className={styles.workertag} src="/images/worker-tag4.png" />}
                    {order?.get('stag') === 5 && <img className={styles.workertag} src="/images/worker-tag5.png" />}
                    <div className={styles.pic}>
                      <img src={order?.getIn(['worker', 'user', 'avatar'])} />
                      <div className={cn(styles.workstatus, order?.get('isActive') ? styles.active : '')}></div>
                    </div>
                    <div className={styles.userinfo}>

                      <div className={styles.userfoot}>
                        <div className={styles.tags}>

                          <VeteranStatus isVeteran={order?.getIn(['worker', 'isVeteran'])} />
                          {order?.getIn(['worker', 'isMargin']) == 1 ?
                            <img src="/images/icon-defend-active.png" style={{ width: 20, height: 20, marginRight: 10 }} /> :
                            <img src="/images/icon-defend.png" style={{ width: 20, height: 20, marginRight: 10 }} />
                          }
                        </div>
                      </div>
                      <div className={styles.tips}>好评率：{order?.getIn(['worker', 'praise']) || 0}% 服务次数：{order?.getIn(['worker', 'order_quantity']) || 0}</div>
                    </div>
                  </div>
                  <OrderRow title="师傅姓名">
                    {order?.getIn(['worker', 'realname'])}
                  </OrderRow>
                  {(isManagerMode || (tenantMode && order?.get('status_code') < 6002 && user.getIn(['staff', 'tenant', 'show_worker_tel']) === 1)) && <OrderRow title="联系电话">
                    <CallNumber show number={order?.getIn(['worker', 'user', 'mobile'])} />
                    {order?.get('status_code') == 4001 &&
                      <Button type="link" icon="message" onClick={remindWorker}>催单消息</Button>
                    }
                  </OrderRow>}
                  <OrderRow title="师傅住址">{order?.getIn(['worker', 'home_address'])}</OrderRow>
                  <OrderRow title="距离客户">{getDistance(
                    order?.getIn(['worker', 'addr_location', 'lat']),
                    order?.getIn(['worker', 'addr_location', 'lng']),
                    order?.getIn(['addr_location', 'lat']),
                    order?.getIn(['addr_location', 'lng']),
                  )}</OrderRow>
                </div>
              }
              <div>
                <SectionTitle title="产品信息"></SectionTitle>

                {
                  order?.get('product_list')?.size > 0 ? order?.get('product_list').map((item, index) => {
                    return (
                      <div key={index}>
                        {order?.get('product_list')?.size > 1 && <div style={{ padding: '0 0 5px 4px', fontSize: '14px', color: '#333', fontWeight: 'bold' }}>产品{index + 1}</div>}
                        <Row gutter={[10, 0]}>
                          <Col span={12}>
                            <OrderRow title="关联产品">{item?.get('name')}</OrderRow>
                          </Col>
                          <Col span={12}>
                            <OrderRow title="产品数量">{item?.get('num')}</OrderRow>
                          </Col>
                          <Col span={12}>
                            {(isManagerMode) &&
                              <OrderRow title="技术电话"><CallNumber show number={order?.get('tech_mobile')} /></OrderRow>
                            }
                            {(tenantMode) &&
                              <OrderRow title="技术电话">{order?.get('tech_mobile')}</OrderRow>
                            }
                          </Col>
                          <Col span={12}>
                            {(isManagerMode) &&
                              <OrderRow title="物流电话"><CallNumber number={order?.get('logistics_mobile')} /></OrderRow>
                            }
                            {(tenantMode) &&
                              <OrderRow title="物流电话">{order?.get('logistics_mobile')}</OrderRow>
                            }
                          </Col>
                          <Col span={12}>
                            <OrderRow title="产品型号">{item?.get('model')}</OrderRow>
                          </Col>
                        </Row>
                        <Col span={12}>
                          <OrderRow title="产品型号">{item?.get('model')}</OrderRow>
                        </Col>
                        <OrderRow title="图片描述">
                          {item?.get('images').map((val, indx) => {
                            return (
                              <Avatar
                                shape="square"
                                size={94}
                                key={indx}
                                src={val.get('url')}
                                style={{ margin: '0 10px 10px 0' }}
                                onClick={() => previewImage(item?.get('images')?.toJS(), indx)}
                              />
                            )
                          })}
                        </OrderRow>
                      </div>
                    )
                  })
                    :
                    <Empty
                      description="无产品信息"
                      image={Empty.PRESENTED_IMAGE_SIMPLE}
                    ></Empty>
                }
              </div>
              <div>
                <SectionTitle title="服务要求"></SectionTitle>
                <Row gutter={[10, 0]}>
                  <Col span={12}>
                    <OrderRow title="是否到货">{
                      order?.get('is_arrival') ? "已到货" : "未到货"
                    }</OrderRow>
                  </Col>
                  <Col span={12}>
                    <OrderRow title="是否上楼">
                      {order?.get('is_up') ? "上楼" : "不上楼"}
                      {order?.get('floor') ? ` / ${order?.get('floor')}层` : ''}
                      {order?.get('is_elevator') ? ` / 有电梯` : " / 无电梯"}
                    </OrderRow>
                  </Col>
                  <Col span={12}>
                    <OrderRow title="是否提货">{order?.get('is_pick') ? "是" : "否"}</OrderRow>
                  </Col>
                </Row>
                <OrderRow title="提货信息">{order?.get('pick_info')}</OrderRow>
                <OrderRow title="服务内容">{order?.get('desc')}</OrderRow>
                <OrderRow title="备注">{order?.get('remark')}</OrderRow>

              </div>
              {order?.get('order_type') == 1 && <div>
                <SectionTitle title="验货信息"></SectionTitle>
                <OrderRow title="验货结果">{order?.getIn(['orderInspection', 'status']) == 0 ? '正常' : (order?.getIn(['orderInspection', 'status']) == 1 ? '异常' : '') || ''}</OrderRow>
                <OrderRow title="图片">
                  <div style={{ padding: '5px 0' }}>
                    <AlbumPreview urls={order?.getIn(['orderInspection', 'resource_file']) || []} />
                  </div>
                </OrderRow>
              </div>}
              {/* {!tenantMode && ( */}
              {/* <Fragment>
              <SectionTitle
                title={!tenantMode ? '备注 (商家不可见)' : '备注 (私密)'}
              ></SectionTitle>
              <MemoList readOnly={readOnly} order={order} />

            </Fragment> */}
              {/* )} */}
              <ProductInfoDialog type="staff" />


            </TabPane>
            <TabPane tab="配件信息" key="2">
              {
                !order?.get('is_return') && order?.get('accessories')?.size == 0 && order?.get('accessories')?.size == 0
                  ?
                  <Empty
                    description="该工单无相关配件及申请，无需返件"
                    image={Empty.PRESENTED_IMAGE_SIMPLE}
                  ></Empty>
                  :
                  ''
              }
              {
                order?.get('is_return') && <div>
                  <SectionTitle title="返件信息">
                    <Button
                      type="primary"
                      style={{ marginLeft: 10 }}
                      size="small"
                      onClick={() => {
                        const copyText = [
                          `返件信息: ${order?.get('return_address') || ''}`,
                          `支付方式: ${order?.get('return_pay') == 1 ? '寄付' : (order?.get('return_pay') == 2 ? '到付' : '') || ''}`,
                          `快递公司: ${order?.get('return_express') || ''}`
                        ]
                        copy(copyText.map(item => item).join('\n'));
                        message.success("复制成功")
                      }}
                    >
                      复制
                    </Button>
                  </SectionTitle>
                  <div>
                    <OrderRow title="返件信息">{order?.get('return_address')}</OrderRow>
                    <OrderRow title="支付方式">
                      {order?.get('return_pay') == 1 && <span>寄付</span>}
                      {order?.get('return_pay') == 2 && <span>到付</span>}
                    </OrderRow>
                    <OrderRow title="快递公司">{order?.get('return_express')}</OrderRow>
                  </div>
                </div>
              }
              {/* <div>
                <SectionTitle title="配件申请单" >
                  <Button
                    type="primary"
                    style={{ marginLeft: 10 }}
                    onClick={handleAddAccessory.bind(this, null, order)}
                    size="small"
                  >
                    添加
                  </Button>
                </SectionTitle>
                <Table columns={accessoryColumns} dataSource={order?.get('accessories')?.toJS()}></Table>
              </div> */}

              {
                order?.get('accessories')?.size > 0 && order?.get('accessories').map((item, index) => {
                  return (
                    <div key={index}>
                      <SectionTitle title="工单配件" >
                        <Button
                          onClick={handleAddAccessory.bind(this, item, order)}
                          type="primary"
                          size="small"
                          style={{ marginLeft: 10 }}
                        >
                          {item && typeof item?.get === 'function' && item?.get('expressNo') ? '修改' : '补发'}
                        </Button>
                      </SectionTitle>
                      {typeof item === 'object' && <div>
                        {order?.get('accessories')?.size > 1 && <div style={{ padding: '0 0 5px 4px', fontSize: '14px', color: '#333', fontWeight: 'bold' }}>配件{index + 1}</div>}
                        <Row gutter={[10, 0]}>
                          <Col span={12}>
                            <OrderRow title="配件名称">{item?.get('name')}</OrderRow>
                          </Col>
                          <Col span={12}>
                            <OrderRow title="配件数量">{item?.get('num')}</OrderRow>
                          </Col>
                          {item?.get('expressNo') && <Col span={12}>
                            <OrderRow title="运单号">
                              <a onClick={handleShowExpressDetail.bind(this, item?.get('expressCompany'), item?.get('expressNo'), item?.get('mobile'))}>
                                {item?.get('expressNo')}
                              </a>
                            </OrderRow>
                          </Col>}
                        </Row>
                        <OrderRow title="申请原因">{item?.get('reason')}</OrderRow>
                        <OrderRow title="图片描述">
                          {item?.get('accessory_images') && item?.get('accessory_images').map((val, indx) => {
                            return (
                              <Tooltip title={val.get('desc')} key={indx}>
                                <Avatar shape="square" size={94} key={indx} src={val.get('url')} style={{ margin: '0 10px 10px 0' }}
                                  onClick={() => previewImage(item?.get('accessory_images')?.toJS(), indx)}
                                />
                              </Tooltip>
                            )
                          })}
                        </OrderRow>
                      </div>}
                    </div>
                  )
                })
              }

              {/* <div>
                <SectionTitle title="物流/返件信息(客户收货与师傅返件信息)" >
                  <Button
                    type="primary"
                    style={{ marginLeft: 10 }}
                    onClick={handleAddExpress}
                    size="small"
                  >
                    {order?.get('express') && order?.get('express').toJS().length > 0 ? '修改' : '添加'}
                  </Button></SectionTitle>
                <Table columns={expressColumns} dataSource={order?.get('express')?.toJS()} />
              </div> */}


              <div>
                <SectionTitle title="工单快递" >
                  <Button
                    type="primary"
                    style={{ marginLeft: 10 }}
                    onClick={handleAddExpress}
                    size="small"
                  >
                    添加
                  </Button>
                </SectionTitle>
                {
                  order?.get('accessories_express')?.size > 0 && order?.get('accessories_express').map((item, index) => {
                    return (
                      <div key={index}>
                        {order?.get('accessories_express')?.size > 1 && <div style={{ padding: '0 0 5px 4px', fontSize: '14px', color: '#333', fontWeight: 'bold' }}>快递{index + 1}</div>}
                        <Row gutter={[10, 0]}>
                          <Col span={12}>
                            <OrderRow title="发货人员">{item?.get('name')}</OrderRow>
                          </Col>
                          <Col span={12}>
                            <OrderRow title="快递公司">{item?.get('expressCompany')}</OrderRow>
                          </Col>
                          <Col span={12}>
                            <OrderRow title="运单号码"><a
                              onClick={handleShowExpressDetail.bind(this, item?.get('expressCompany'), item?.get('expressNo'), item?.get('mobile'))}
                            >{item?.get('expressNo')}</a></OrderRow>
                          </Col>
                          <Col span={12}>
                            <OrderRow title="快递状态">{item?.get('expressStatus')}</OrderRow>
                          </Col>
                        </Row>
                        <OrderRow title="备注">{item?.get('remark')}</OrderRow>
                      </div>
                    )
                  })
                }
              </div>

            </TabPane>
            <TabPane tab="完单/评价" key="3">
              <div>
                <SectionTitle title="师傅反馈图"></SectionTitle>
                {order?.get('feedback_images')?.size > 0 ? <div>
                  {order?.get('feedback_images').map((item, index) => (
                    <Tooltip title={item?.get('desc')} key={index}>
                      <Avatar shape="square" size={94} src={item?.get('url')}
                        style={{ margin: '0 10px 10px 0' }}
                        onClick={() => previewImage(orderJs.feedback_images, index)} />
                    </Tooltip>
                  ))}
                </div> :
                  <Empty
                    description="师傅暂未提交反馈图"
                    image={Empty.PRESENTED_IMAGE_SIMPLE}
                  ></Empty>
                }
              </div>
              {Object.keys(evaluateInfo).length > 0 && <div>
                <SectionTitle title="客户评价"></SectionTitle>
                <div>
                  <Row gutter={[10, 0]}>
                    <Col span={12}>
                      <OrderRow title="专业技术">
                        <Rate disabled count={5} value={evaluateInfo?.technology} style={{ color: '#FF6600', fontSize: 16 }} />
                      </OrderRow>
                    </Col>
                    <Col span={12}>
                      <OrderRow title="服务态度">
                        <Rate disabled count={5} value={evaluateInfo?.manner} style={{ color: '#FF6600', fontSize: 16 }} />
                      </OrderRow>
                    </Col>
                    <Col span={12}>
                      <OrderRow title="处理速度">
                        <Rate disabled count={5} value={evaluateInfo?.speed} style={{ color: '#FF6600', fontSize: 16 }} />
                      </OrderRow>
                    </Col>
                  </Row>

                  <OrderRow title="客户评价">{evaluateInfo?.comment}</OrderRow>
                  <OrderRow title="安装照片">
                    {evaluateInfo?.images?.length > 0 && <div>
                      {evaluateInfo?.images.map((item, index) => (
                        <Avatar shape="square" size={94} src={item} key={index}
                          style={{ margin: '0 10px 10px 0' }}
                          onClick={() => previewImage(evaluateInfo?.images?.map(v => ({ url: v })), index)}
                        />
                      ))}
                    </div>}
                  </OrderRow>
                  <OrderRow title="评价时间">{
                    evaluateInfo.createdAt
                      ? dayjs(evaluateInfo.createdAt).format("YYYY-MM-DD HH:mm:ss")
                      : ""
                  }</OrderRow>
                </div>
              </div>}
              {claimOkList?.length > 0 && <div>
                <SectionTitle title="索赔记录"></SectionTitle>
                {claimOkList?.map((item, index) => <div>
                  {claimOkList?.length > 1 && <div
                    style={{ padding: '0 0 5px 4px', fontSize: '14px', color: '#333', fontWeight: 'bold' }}
                  >索赔记录{index + 1}</div>}
                  <OrderRow title="索赔金额">
                    <span className={styles.textcolor1}>
                      {item?.sp_amount}元
                    </span>
                  </OrderRow>
                  <OrderRow title="索赔时间">{
                    item.sp_time
                      ? dayjs(item.sp_time).format("YYYY-MM-DD HH:mm:ss")
                      : ""
                  }</OrderRow>
                  <OrderRow title="索赔原因">{item?.sp_reason}</OrderRow>
                </div>)}
              </div>}
              {evaluateInfo.is_appeal && <div>
                <SectionTitle title="评价申诉"></SectionTitle>

                <OrderRow title="申诉原因">{evaluateInfo.appeal_reason}</OrderRow>
                <OrderRow title="安装照片">
                  {evaluateInfo?.appeal_images?.length > 0 && <div>
                    {evaluateInfo?.appeal_images.map((item, index) => (
                      <Avatar shape="square" size={94} src={item.url} key={index}
                        style={{ margin: '0 10px 10px 0' }}
                      />
                    ))}
                  </div>}
                </OrderRow>
                <OrderRow title="申诉时间">{
                  evaluateInfo.appeal_time
                    ? dayjs(evaluateInfo.appeal_time).format("YYYY-MM-DD HH:mm:ss")
                    : ""
                }</OrderRow>

              </div>}
              {evaluateInfo.is_appeal && <div>
                <SectionTitle title="申诉审核"></SectionTitle>

                <OrderRow title="审核客服">{evaluateInfo?.tenantAssignTo?.name || ""}</OrderRow>
                <OrderRow title="审核结果">{evaluateInfo?.appeal_flag == 2 ? "拒绝" : "同意"}</OrderRow>
                <OrderRow title="拒绝原因">{evaluateInfo?.refuse_reason || ""}</OrderRow>
                <OrderRow title="审核时间">{
                  evaluateInfo.check_time
                    ? dayjs(evaluateInfo.check_time).format("YYYY-MM-DD HH:mm:ss")
                    : ""
                }</OrderRow>
              </div>}

            </TabPane>
            <TabPane tab="工单备注" key="4">
              {!readOnly && <div className={styles.memotextArea}>
                <Input.TextArea rows={6} value={memoValue} placeholder="请输入备注信息"
                  onChange={(e) => { setMemoValue(e.target.value) }} />
                <div className={styles.btns}>
                  <Button
                    type="primary"
                    size="small"
                    onClick={() => {
                      submitMemo()
                    }}
                  >
                    保存
                  </Button>
                </div>
              </div>}
              {(isManagerMode && serviceMemo.length > 0) && <div>
                <SectionTitle title="客服备注历史"></SectionTitle>

                <div className={styles.commenthistory}>
                  {
                    serviceMemo.map((item, index) => (
                      <div className={styles.historyitem} key={index}>
                        <div className={styles.itemhead}>
                          <div className={styles.time}>
                            {dayjs(item.createdAt).format("YYYY-MM-DD HH:mm:ss")}
                            <span className={styles.name}>{item?.user?.name}</span>
                          </div>
                          <div className={styles.other} >
                            {/* <Button type="link" icon="delete" size="large"></Button> */}
                          </div>
                        </div>
                        <div className={styles.text}>{item.memo}</div>
                      </div>)
                    )
                  }
                </div>
              </div>}
              {businessMemo.length > 0 && <div>
                <SectionTitle title="商家备注历史"></SectionTitle>

                <div className={cn(styles.commenthistory, styles.bg1)}>
                  {
                    businessMemo.map((item, index) => (<div className={styles.historyitem} key={index}>
                      <div className={styles.itemhead}>
                        <div className={styles.time}>
                          {dayjs(item.createdAt).format("YYYY-MM-DD HH:mm:ss")}
                          <span className={styles.name}>{item?.user?.name}</span>
                        </div>
                        <div className={styles.other} >
                        </div>
                      </div>
                      <div className={styles.text}>{item.memo}</div>
                    </div>))
                  }
                </div>
              </div>}
              {(isManagerMode && workerMemo.length > 0) && <div>
                <SectionTitle title="师傅备注历史"></SectionTitle>

                <div className={cn(styles.commenthistory, styles.bg2)}>
                  {
                    workerMemo.map((item, index) => (<div className={styles.historyitem} key={index}>
                      <div className={styles.itemhead}>
                        <div className={styles.time}>
                          {dayjs(item.createdAt).format("YYYY-MM-DD HH:mm:ss")}
                          <span className={styles.name}>{item?.user?.name}</span>
                        </div>
                        <div className={styles.other} >
                        </div>
                      </div>
                      <div className={styles.text}>{item.memo}</div>
                    </div>))
                  }
                </div>
              </div>}
            </TabPane>
            <TabPane tab="服务信息" key="5">
              <div className={styles.timelinewrap}>
                <Timeline>
                  {events.map(it => {
                    return (it.event ? <Timeline.Item key={it.time}
                      dot={<span style={{ display: 'flex', width: '10px', height: '10px', background: '#026431', borderRadius: '50%' }}></span>}
                    >
                      <div className={styles.title}>{getLabel(it)}</div>
                      {it.event == orderStatus.WAIT_RECIEW && <div className={styles.peoplewrap}>
                        <div className={styles.label}>下单人</div>
                        <div className={styles.info}>
                          <div className={styles.pic}>
                            <Avatar size="large" src={it?.order?.tenant?.logo} icon="user" />
                            <div className={cn(styles.workstatus, it?.order?.tenant?.active ? styles.active : '')}></div>
                          </div>
                          <div className={styles.userinfo}>
                            <div className={styles.userfoot}>

                            </div>
                            <div className={styles.tips}>
                              {it?.order?.tenant?.short_name}
                              {(it?.order?.tenant?.short_name && it?.order?.tenant?.contact_name) ? '/' : ''}
                              {it?.order?.tenant?.contact_name}
                            </div>
                            <div className={styles.tips}>
                              {it?.order?.tenant?.owner?.remark || ''}
                              {(it?.order?.tenant?.owner?.remark && it?.order?.tenant?.contact_tel) ? '/' : ''}
                              {it?.order?.tenant?.contact_tel}
                            </div>
                          </div>
                        </div>
                      </div>}
                      {it.event == orderStatus.WAIT_PRICING && <div className={styles.peoplewrap}>
                        <div className={styles.label}>服务客服</div>
                        <div className={styles.info}>
                          <div className={styles.pic}>
                            {/* <img src={it?.user?.avatar} /> */}
                            <Avatar size="large" src={it?.user?.avatar} icon="user" />
                            <div className={cn(styles.workstatus, it?.user?.isActive ? styles.active : '')}></div>
                          </div>
                          <div className={styles.userinfo}>
                            <div className={styles.tips}>
                              {it?.user?.name}
                            </div>
                            <div className={styles.tips}></div>
                          </div>
                        </div>
                      </div>}
                      {it.event == orderStatus.PROCESSING_WAIT_APPOINTMENT && <div className={styles.peoplewrap}>
                        <div className={styles.label}>服务师傅</div>
                        <div className={styles.info}>
                          <div className={styles.pic}>
                            {/* <img src={it?.order?.worker?.user?.avatar} /> */}
                            <Avatar size="large" src={it?.order?.worker?.user?.avatar} icon="user" />
                            <div className={cn(styles.workstatus, it?.order?.worker?.isActive ? styles.active : '')}></div>
                          </div>
                          <div className={styles.userinfo}>
                            <div className={styles.userfoot}>
                              <div className={styles.tags}>
                                <VeteranStatus isVeteran={it?.order?.worker?.isVeteran} />
                                {it?.order?.worker?.isMargin == 1 ?
                                  <img src="/images/icon-defend-active.png" style={{ width: 20, height: 20, marginRight: 10 }} /> :
                                  <img src="/images/icon-defend.png" style={{ width: 20, height: 20, marginRight: 10 }} />
                                }
                              </div>
                            </div>
                            <div className={styles.tips}>
                              {it?.order?.worker?.realname}/{it?.order?.worker?.backup_phone}
                            </div>
                            <div className={styles.tips}>
                              好评率：{it?.order?.worker?.praise || 0}% 服务次数：{it?.order?.worker?.order_quantity || 0}
                            </div>
                          </div>

                        </div>
                      </div>}

                      {it.event == orderStatus.CANCEL && <div>
                        {(() => {
                          const roles = Object.keys(it?.user?.roles)
                          if (roles?.includes('manager') || roles?.includes('staff')) {
                            return (
                              <>
                                <div>客服：{it?.user?.name}</div>
                                <div>取消原因：{it?.order?.cancel_reason || ''}</div>
                              </>)
                          } else if (roles?.includes('retail')) {
                            return (
                              <>
                                <div>散户：{it?.user?.name}</div>
                                <div>取消原因：{it?.order?.cancel_reason || ''}</div>
                              </>)
                          } else {
                            return (
                              <>
                                <div>师傅：{it?.user?.name}</div>
                                <div>取消原因：{it?.order?.worker_cancel_reason || ''}</div>
                              </>)
                          }
                        })()}
                      </div>}

                      {/* 
                      验收不通过-免费上门、审批散户免费上门申请
                      师傅验货正常、师傅验货异常
                       */}
                      {[
                        orderStatus.ACCEPT_FAILED_FREE_ON_SITE,
                        orderStatus.CHECK_ACCEPT_FAILED_ON_SITE,
                        orderStatus.WORKER_ORDERINSPECT_NORMAL,
                        orderStatus.WORKER_ORDERINSPECT_ABNORMAL,
                      ].includes(Number(it.event)) && <div style={{
                        background: '#eee',
                        padding: 10,
                        borderRadius: 4
                      }}>
                          {(it?.info?.reason || it?.info?.remark) && <div style={{ padding: '5px 0' }}>原因：{it?.info?.reason || it?.info?.remark}</div>}
                          {/* {it?.info?.remark && <div style={{ padding: '5px 0' }}>原因：{it?.info?.remark}</div>} */}
                          {Array.isArray(it?.info?.resource_file) && <div style={{ padding: '5px 0' }}>
                            <AlbumPreview urls={it?.info?.resource_file} />
                          </div>}
                        </div>
                      }

                      {/* 
                      师傅申请仲裁、散户申请仲裁
                      散户申请仲裁申诉、师傅申请仲裁申诉
                      客服同意仲裁、客服拒绝仲裁
                       */}
                      {[
                        orderStatus.WORKER_APPLY_ARBITRATION,
                        orderStatus.RETAIL_APPLY_ARBITRATION,
                        orderStatus.RETAIL_APPLY_ARBITRATION_APPEAL,
                        orderStatus.WORKER_APPLY_ARBITRATION_APPEAL,
                        orderStatus.MANAGER_ARBITRATION_APPEAL_AGREE,
                        orderStatus.MANAGER_ARBITRATION_APPEAL_REFRUSE,
                      ].includes(Number(it.event)) && <div style={{
                        background: '#eee',
                        padding: 10,
                        borderRadius: 4
                      }}>
                          {it?.info?.intro && <div style={{ padding: '5px 0' }}>原因：{it?.info?.intro}</div>}
                          {Array.isArray(it?.info?.resourceFile) && <div style={{ padding: '5px 0' }}>
                            <AlbumPreview urls={it?.info?.resourceFile} />
                          </div>}
                        </div>
                      }

                      {/* 
                      散户申请退款、
                      师傅拒绝退款
                       */}
                      {[
                        orderStatus.RETAIL_APPLY_BACK,
                        orderStatus.WORKER_APPLY_BACK_REFUSE,
                      ].includes(Number(it.event)) && <div style={{
                        background: '#eee',
                        padding: 10,
                        borderRadius: 4
                      }}>
                          {it?.info?.back_money && <div style={{ padding: '5px 0' }}>金额：{it?.info?.back_money}元</div>}
                          {it?.info?.back_reason && <div style={{ padding: '5px 0' }}>原因：{it?.info?.back_reason}</div>}
                          {Array.isArray(it?.info?.resource_file) && <div style={{ padding: '5px 0' }}>
                            <AlbumPreview urls={it?.info?.resource_file} />
                          </div>}
                        </div>
                      }

                      {/* 
                      拒绝师傅申请费用
                      散户申请新增费用并支付
                      散户申请下调费用
                      拒绝散户申请下调费用、拒绝师傅申请费用
                       */}
                      {[
                        orderStatus.WORKER_APPLY_FEE,
                        orderStatus.RETAIL_UP_APPLY_FEE,
                        orderStatus.DOWN_APPLY_FEE,
                        orderStatus.CHECK_DOWN_APPLY_FEE_REFUSE,
                        orderStatus.CHECK_WORKER_APPLY_FEE_REFUSE,
                      ].includes(Number(it.event)) && <div style={{
                        background: '#eee',
                        padding: 10,
                        borderRadius: 4
                      }}>
                          {Array.isArray(it.info.detail) && <div style={{ display: 'flex', flexWrap: 'wrap', gap: '20px' }}>
                            {it.info.detail.map((v, i) => <div key={i}>
                              {v.fee_name || v.name || ''}：{v.fee_value || v.price || '-'}元
                            </div>)}
                          </div>}
                          {it?.info?.reason && <div style={{ padding: '5px 0' }}>原因：{it?.info?.reason}</div>}
                          {/* {Array.isArray(it?.info?.resource_file) && <div style={{ padding: '5px 0' }}>
                            <AlbumPreview urls={it?.info?.resource_file} />
                          </div>} */}
                        </div>
                      }

                      {/* 
                      商家索赔
                       */}
                      {[
                        orderStatus.TENANT_CLAIM,
                      ].includes(Number(it.event)) && <div style={{
                        background: '#eee',
                        padding: 10,
                        borderRadius: 4
                      }}>
                          {it?.info?.sp_amount && <div style={{ padding: '5px 0' }}>金额：{it?.info?.sp_amount}元</div>}
                          {it?.info?.sp_reason && <div style={{ padding: '5px 0' }}>原因：{it?.info?.sp_reason}</div>}
                          {Array.isArray(it?.info?.images) && <div style={{ padding: '5px 0' }}>
                            <AlbumPreview urls={it?.info?.images} />
                          </div>}
                        </div>
                      }

                    </Timeline.Item> : '')
                  })}
                </Timeline>
              </div>
            </TabPane>
          </Tabs>
        </div>
      </div>

      {(
        !readOnly
        // &&
        // (
        //   (tenantMode && (
        //     order?.get('ticket_type') != 2 ||
        //     (order?.get('ticket_type') == 2 && order?.get('status_code') <= orderStatus.WAIT_ASSIGN)
        //   )) ||
        //   isManagerMode
        // )
      ) &&
        (<div className={styles.submitBar}>
          <div className={styles.barleft}>
            {order?.get('status_code') === orderStatus.PROCESSING_WAIT_APPOINTMENT && (
              <>
                <div className={styles.countdown}>
                  <div className={styles.tips}>预约剩余时间</div>
                  <Countdown time={dayjs(order?.get('worker_assigned_at') || 0).valueOf() - dayjs().valueOf() + 1000 * 60 * 60 * 2}
                  />
                </div>
              </>
            )}
          </div>
          <div className={styles.barright}>
            {(tenantMode && order?.get('showEvaluate')) && <Button size="small" block shape="round"
              onClick={() => {
                dispatch(showOrderEvaluateDialog({ orderId: order?.get('_id'), workerId: order?.getIn(['worker', '_id']) }))
              }}>工单评价</Button>}

            {!platformChecked ? <>
              {/* 待指派 */}
              {(
                // (order?.get('status_code') === orderStatus.WAIT_ASSIGN)
                (order?.get('status_code') === orderStatus.WAIT_ASSIGN && isManagerMode) ||
                (order?.get('status_code') === orderStatus.WAIT_ASSIGN && tenantMode && order?.get('ticket_type') == 2)
              ) && (
                  <>
                    <Button size="small" block type="primary" shape="round" onClick={handleAssignWorker}>
                      <div style={{
                        display: 'flex', alignItems: 'center',
                        justifyContent: 'center'
                      }}>
                        <BlinkingBadge count={order?.get('quotationNum')} style={{ transform: 'scale(0.8)', marginRight: 6 }} />
                        <span>查看报价/指派师傅</span>
                      </div>
                    </Button>
                    {/* {order?.getIn(['tip', 0, 'type']) == 99 && <Button size="small" block type="primary" shape="round" onClick={handleChangeFixedPrice}>{order?.get('is_new')}发布一口价工单</Button>} */}
                    {order?.get('is_new') == 1 && <Button size="small" block type="primary" shape="round" onClick={handleChangeFixedPrice}>发布一口价工单</Button>}
                  </>
                )}
              {/* 待预约 、待上门 */}
              {(
                (order?.get('status_code') === orderStatus.PROCESSING_WAIT_APPOINTMENT ||
                  order?.get('status_code') === orderStatus.PROCESSING_WAIT_SERVICE ||
                  order?.get('status_code') === orderStatus.WORKER_LOCATION_CHECKED ||
                  order?.get('status_code') === orderStatus.ORDER_INSPECTION ||
                  order?.get('status_code') === orderStatus.PROCESSING_COMPLETED
                ) &&
                (
                  isManagerMode ||
                  (tenantMode && order?.get('ticket_type') == 2)
                )
              ) && (
                  <>
                    <Button size="small" block shape="round" type="primary" ghost onClick={handleAssignWorker}>重新指派师傅</Button>
                    {order?.get('status_code') === orderStatus.WAIT_ASSIGN && order?.get('is_new') == 1 && <Button size="small" block type="primary" shape="round" ghost onClick={handleChangeFixedPrice}>发布一口价工单</Button>}
                  </>
                )}
              {/* 待预约 */}
              {(
                (tenantMode &&
                  (
                    order?.get('status_code') === orderStatus.WAIT_ASSIGN ||
                    (
                      order?.get('status_code') === orderStatus.PROCESSING_WAIT_APPOINTMENT &&
                      dayjs(order?.get('worker_assigned_at') || 0).valueOf() + 1000 * 60 * 60 > dayjs().valueOf()
                    )
                  )
                ) ||
                (
                  isManagerMode && (
                    order?.get('status_code') === orderStatus.WAIT_ASSIGN ||
                    order?.get('status_code') === orderStatus.WORKER_LOCATION_CHECKED ||
                    order?.get('status_code') === orderStatus.ORDER_INSPECTION ||
                    order?.get('status_code') === orderStatus.PROCESSING_COMPLETED
                  )
                )
              ) && (
                  <>
                    {isManagerMode && order?.get('is_retail') ? (
                      <Tooltip title="保外工单，客服不能取消">
                        <Button size="small" block shape="round" type="primary" ghost disabled>取消工单</Button>
                      </Tooltip>
                    ) : (
                      <CancelOrder order={order}>
                        <Button size="small" block shape="round" type="primary" ghost>取消工单</Button>
                      </CancelOrder>
                    )}
                  </>
                )}
              {/* 待预约 、待上门、正在上门 */}
              {(
                (
                  (order?.get('status_code') === orderStatus.PROCESSING_WAIT_APPOINTMENT && tenantMode) ||
                  (order?.get('status_code') === orderStatus.PROCESSING_WAIT_SERVICE && tenantMode) ||
                  ((order?.get('status_code') === orderStatus.WORKER_LOCATION_CHECKED || order?.get('status_code') === orderStatus.ORDER_INSPECTION) && (
                    isManagerMode || (tenantMode && order?.get('ticket_type') == 2))
                  )
                ) &&
                !order?.get('is_guaqi')
              ) && (
                  <>
                    <GuaqiOrder order={order} change={() => { fetchOrderEvent(orderId) }}>
                      <Button size="small" block shape="round" type="primary" ghost>挂起</Button>
                    </GuaqiOrder>
                  </>
                )}
              {/* 待预约|挂起、待上门、待上门|挂起、正在上门|挂起 */}
              {(
                (order?.get('status_code') === orderStatus.PROCESSING_WAIT_APPOINTMENT && order?.get('is_guaqi') && tenantMode) ||
                (order?.get('status_code') === orderStatus.PROCESSING_WAIT_SERVICE && tenantMode) ||
                (order?.get('status_code') === orderStatus.PROCESSING_WAIT_SERVICE && order?.get('is_guaqi') && tenantMode) ||
                (order?.get('status_code') === orderStatus.WORKER_LOCATION_CHECKED && order?.get('is_guaqi'))
              ) && (
                  <>
                    <Button size="small" block shape="round" type="primary" ghost
                      onClick={handleChangeServiceTime}>修改预约时间</Button>
                  </>
                )}
              {/* 待预约 */}
              {(
                // (order?.get('status_code') === orderStatus.PROCESSING_WAIT_APPOINTMENT && tenantMode)
                (order?.get('status_code') === orderStatus.PROCESSING_WAIT_APPOINTMENT && order?.get('ticket_type') == 2 && tenantMode)
              ) && (
                  <>
                    <Button size="small" block type="primary" shape="round" onClick={handleChangeServiceTime}>预约时间</Button>
                  </>
                )}
              {/* 待预约|挂起、待上门、待上门|挂起 */}
              {(
                order?.get('status_code') === orderStatus.WAIT_ASSIGN ||
                order?.get('status_code') === orderStatus.PROCESSING_WAIT_APPOINTMENT ||
                order?.get('status_code') === orderStatus.PROCESSING_WAIT_SERVICE ||
                order?.get('status_code') === orderStatus.WORKER_LOCATION_CHECKED ||
                order?.get('status_code') === orderStatus.ORDER_INSPECTION
                // ||
                // (order?.get('status_code') === orderStatus.PROCESSING_WAIT_APPOINTMENT && order?.get('ticket_type') == 2)
              ) && (
                  <>
                    <Button size="small" block shape="round" type="primary" ghost
                      onClick={remindWorker}
                    >催单</Button>
                  </>
                )}
              {/* 待预约 、待上门 */}
              {(
                (
                  order?.get('status_code') === orderStatus.PROCESSING_WAIT_APPOINTMENT ||
                  order?.get('status_code') === orderStatus.PROCESSING_WAIT_SERVICE
                ) &&
                isManagerMode
              ) && (
                  <>
                    <Dropdown overlay={(
                      <Menu>
                        {(
                          order?.get('status_code') === orderStatus.PROCESSING_WAIT_APPOINTMENT ||
                          order?.get('status_code') === orderStatus.PROCESSING_WAIT_SERVICE

                        ) && <Menu.Item>
                            <CancelOrder order={order}>
                              <Button block type="link">取消工单</Button>
                            </CancelOrder>
                          </Menu.Item>}
                        {!order?.get('is_guaqi') && <Menu.Item>
                          <GuaqiOrder order={order} change={() => { fetchOrderEvent(orderId) }}>
                            <Button block type="link">挂起</Button>
                          </GuaqiOrder>
                        </Menu.Item>}
                        {(order?.get('status_code') === orderStatus.PROCESSING_WAIT_APPOINTMENT && !order?.get('is_guaqi')) && <Menu.Item>
                          <Button block type="link" onClick={handleChangeServiceTime}>预约时间</Button>
                        </Menu.Item>}
                        {(
                          (order?.get('status_code') === orderStatus.PROCESSING_WAIT_APPOINTMENT && order?.get('is_guaqi')) ||
                          order?.get('status_code') === orderStatus.PROCESSING_WAIT_SERVICE ||
                          (order?.get('status_code') === orderStatus.PROCESSING_WAIT_SERVICE && order?.get('is_guaqi'))
                        ) && <Menu.Item>
                            <Button block type="link" onClick={handleChangeServiceTime}>修改预约时间</Button>
                          </Menu.Item>}
                      </Menu>
                    )} placement="topRight">
                      <Button size="small" block shape="round" type="primary" ghost>更多</Button>
                    </Dropdown>
                  </>
                )}
              {/* 待客服确认 */}
              {(
                order?.get('status_code') === orderStatus.PROCESSING_COMPLETED ||
                order?.get('status_code') === orderStatus.PROCESSING_WAIT_TENANT_RECEIPT
              ) && (

                  <ControlBtns
                    tenantMode={tenantMode}
                    orderId={orderId}
                    order={order}
                    workerFeeTotal={calTenantFeeTotal(
                      order?.get('worker_fee_total'),
                      order?.get('worker_services')?.toJS(),
                      order?.get('worker_deduction')?.toJS()
                    )}
                  />
                )}
              {/* 工单完成、工单关闭（已结算） */}
              {!tenantMode && (
                order?.get('status_code') == orderStatus.DONE ||
                order?.get('status_code') == orderStatus.DONE_CLOSE
              ) && (
                  (user.get('isTouer') &&
                    order?.get('tenant_deduction')
                  ) || !user.get('isTouer')
                ) &&
                <Button
                  size="small"
                  block type="primary" shape="round"
                  onClick={showDeductionDialogHandler(orderJs.tenant_deduction, order._id, 2, null)}
                >
                  申请调价
                </Button>
              }
            </> : <>
              {(
                (tenantMode &&
                  (
                    (order?.get('status_code') === orderStatus.PROCESSING_COMPLETED && order?.get('ticket_type') == 1) ||
                    (order?.get('status_code') === orderStatus.DONE_CLOSE)
                  )
                ) ||
                (
                  isManagerMode && order?.get('status_code') === orderStatus.DONE_CLOSE
                )
              ) && <Button size="small" block shape="round"
                onClick={() => {
                  dispatch(
                    showAppealDialog({
                      title: '申诉/索赔',
                      order: order?.toJS(),
                      appeal: order?.get('appeal')?.toJS(),
                      order_id: orderId,
                      type: 1, //申请类型 0 商家申请返款 1申请对师傅扣款 2申请对商家扣款
                      isAppealClaim: true,
                      user: user
                    })
                  )
                }}>申诉/索赔</Button>}
              {/* <Button
                block type="primary" shape="round"
                onClick={showDeductionDialogHandler(orderJs.tenant_deduction, order._id, 2, null)}
              >
                申请调价
              </Button> */}
            </>}
          </div>
        </div>)}

      {/* 改价 */}
      <ChangePrice />
      <AddExpress />
      <ExpressDetail />
      <AddAccessory />

      <Reminder title="催单" />

      <AssignWorkerDialog
        title="指派师傅"
        id={order?.get('_id')}
        order={order}
      />
      <ChangeServiceTimeDialog
        title="更改预约时间"
        id={order?.get('_id')}
        order={order}
      />
      <OrderEvaluateDialog title="工单评价" />
    </div>
  );
}
